<template lang="html">

  <article class="encuesta-el row-between container" v-if="!!data">
    <div class="textos">
      <h3 class="fecha" v-if="!!data.fecha">{{data.fecha}}</h3>
      <h2 class="titulo">{{data.titulo}}</h2>
    </div>
    <router-link v-if="data.enlace" class="link" :to="$t('enlaces.encuesta')+'/'+data.enlace">Comenzar</router-link>
    <router-link v-if="data.enlace" class="enlace-cover" :to="$t('enlaces.encuesta')+'/'+data.enlace">Ir a la encuesta</router-link>
    <h3 class="contestada" v-if="!!data.contestada & !!!data.enlace">Contestada</h3>
  </article>

</template>

<script lang="js">



  export default {
    name: 'encuesta-el',
    props : ['data'],
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/encuesta-el.vue